import TagAlertValue from '@/modules/core/models/TagAlertValue'

export default class DentalConfigurationTags {
  relationshipAlert: TagAlertValue
  holderAlert: TagAlertValue
  personalDataAlert: TagAlertValue
  personalDataInsuredAlert: TagAlertValue
  contactDataAlert: TagAlertValue
  contactDataInsuredAlert: TagAlertValue
  customDateAlert: TagAlertValue
  hasHealthInsuranceMeTitle: string
  hasHealthInsuranceMeAlert: TagAlertValue
  hasHealthInsuranceMeAndOthersTitle: string
  hasHealthInsuranceMeAndOthersAlert: TagAlertValue
  hasHealthInsuranceOthersTitle: string
  hasHealthInsuranceOthersAlert: TagAlertValue
  hasHealthInsuranceOtherTitle: string
  hasHealthInsuranceOtherAlert: TagAlertValue
  familyDiscountHintView: {
    label: string
    text1: string
    text2: string
    forOnlyFamilyBtn: string
    forAllBtn: string
  }
  policyNumberAlert: TagAlertValue

  constructor(data: DentalConfigurationTags) {
    this.relationshipAlert = new TagAlertValue(data.relationshipAlert)
    this.holderAlert = new TagAlertValue(data.holderAlert)
    this.personalDataAlert = new TagAlertValue(data.personalDataAlert)
    this.personalDataInsuredAlert = new TagAlertValue(data.personalDataInsuredAlert)
    this.contactDataAlert = new TagAlertValue(data.contactDataAlert)
    this.contactDataInsuredAlert = new TagAlertValue(data.contactDataInsuredAlert)
    this.customDateAlert = new TagAlertValue(data.customDateAlert)
    this.hasHealthInsuranceMeTitle = data.hasHealthInsuranceMeTitle
    this.hasHealthInsuranceMeAlert = new TagAlertValue(data.hasHealthInsuranceMeAlert)
    this.hasHealthInsuranceMeAndOthersTitle = data.hasHealthInsuranceMeAndOthersTitle
    this.hasHealthInsuranceMeAndOthersAlert = new TagAlertValue(
      data.hasHealthInsuranceMeAndOthersAlert
    )
    this.hasHealthInsuranceOthersTitle = data.hasHealthInsuranceOthersTitle
    this.hasHealthInsuranceOthersAlert = new TagAlertValue(data.hasHealthInsuranceOthersAlert)
    this.hasHealthInsuranceOtherTitle = data.hasHealthInsuranceOtherTitle
    this.hasHealthInsuranceOtherAlert = new TagAlertValue(data.hasHealthInsuranceOtherAlert)
    this.familyDiscountHintView = data.familyDiscountHintView
    this.policyNumberAlert = new TagAlertValue(data.policyNumberAlert)
  }
}
